import "./services/providers/register-providers";
import { createRoot } from "react-dom/client";
import { installChunkErrorHandler } from "./lib/chunk-reload";
import App from "./App";
import "./index.css";

// Handle stale chunk errors after deployments by auto-reloading
installChunkErrorHandler();

createRoot(document.getElementById("root")!).render(
  <>
    <App />
  </>
);
